Ext.define('SA.view.RadioGroup', {
    alias: 'widget.sa-radio-group',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-radio-group',
    direction: 'column',

    beforeRender() {
        this.callParent();

        this.addCls('sa-radio-group-' + this.direction);
    },

    afterRender() {
        this.callParent();

        this.el.dom.setAttribute('role', 'radiogroup');
    },

    disable() {
        this.setDisabled(true);
    },

    enable() {
        this.setDisabled(false);
    },

    enableExcept(values) {
        this.getRadioButtons().filter(button => !values.includes(button.value)).forEach(button => button.enable());
    },

    getChecked() {
        return this.getRadioButtons().find(radio => radio.isChecked());
    },

    getRadioButtons() {
        return this.query('sa-radio');
    },

    getValue() {
        var radio = this.getChecked();

        return radio && radio.value;
    },

    initItems(items) {
        items = items.map(item => Object.assign({xtype: 'sa-radio'}, item));

        items = this.callParent([items]);

        items.forEach(item => {
            item.on('change', this.onRadioChange, this);
        });

        return items;
    },

    onRadioChange(radio, checked) {
        if (!checked) {
            return;
        }

        this.getRadioButtons().forEach(otherRadio => {
            otherRadio.setChecked(otherRadio === radio);
        });

        this.fireEvent('change', this, this.getValue());
    },

    setDisabled(disabled) {
        this.getRadioButtons().forEach(radio => {
            radio.setDisabled(disabled);
        });
    },

    setValue(value) {
        this.getRadioButtons().forEach(radio => {
            radio.setChecked(radio.value === value);
        });
    }
});
